<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div> -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <!-- <el-tab-pane name="jsgl"> -->
        <!-- <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 新增
        </span> -->
        <!-- <normalNav :parent="self">
          <button class="OrangeSmBtn">新增</button>
          <button class="GreenSmBtn">重置</button>
          <button class="BlueSmBtn">搜索</button>
        </normalNav> -->
        <div class="seeDetail">
			<div class="data">
				<el-steps :active="step" simple finish-status="success" process-status="finish">
					<el-step @click.native="on_click(1)" title="设备关联" :icon="step<1?'el-icon-edit':'el-icon-circle-check'"></el-step>
					<!-- <el-step @click.native="on_click(2)" title="告警关联" :icon="step<2?'el-icon-edit':'el-icon-circle-check'"></el-step> -->
					<el-step @click.native="on_click(2)" title="指令关联" :icon="step<2?'el-icon-edit':'el-icon-circle-check'"></el-step>
					<el-step @click.native="on_click(3)" title="联动关联" :icon="step<3?'el-icon-edit':'el-icon-circle-check'"></el-step>
				</el-steps>
				<step1Device v-if="step==0&&relevance=='device'" @next="fNext" @device="fDevice"></step1Device>
				<step1Area v-if="step==0&&relevance=='area'" @next="fNext"></step1Area>
				<!-- <step2 v-if="step==1" :step1="data.step1" @next="fNext"></step2> -->
				<step3 v-if="step==1" :data="data" :device="device" :tridevId="tridevId" :relevance="relevance" @next="fNext"></step3>
				<step4 v-if="step==2" :oriTriggerId="tridevId" :oriAreaId="data.step1.a_id" :oriDeviceIds="data.step1.devices"></step4>
			</div>
		</div>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      tabName: 'jsgl',
      relevance: "",
      tridevId: "",
      step: 0,
      data: {},
      device: {}
    };
  },
  components: {
    step1Device: () => import("./step1/device"),
    step1Area: () => import("./step1/area"),
    step2: () => import("./step2"),
    step3: () => import("./step3"),
    step4: () => import("./step4")
  },
  methods: {
    fNext(payload) {
      //console.log(payload,"111")
      //console.log(this.data,"222")
      this.$set(this.data, `step${this.step + 1}`, payload);
      this.step++;
    },
    fDevice(value) {
      this.device = value;
      //console.log(this.device,"fDevice")
    },
    on_click(val) {
      //console.log(val)
      if(val < this.step || val === this.step) {
        if(val === 1) {
          this.step = 1;
          //console.log(this.step,"step")
        }
      }
    }
  },
  mounted() {
    this.tridevId = this.$route.params.id;
    this.relevance = this.$route.params.relevanceType;
  }
};
</script>

<style scoped lang="less">
.el-steps {
  border: 1px solid #3d4963;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/tridev/add/index.vue